export enum CheckInOption {
  App = 'checkInApp',
  Card = 'checkInCard',
  Issuing = 'hansefitCard',
  Twogether = 'twogether',
}
